import { defineMessages } from 'react-intl';

const messages = defineMessages({
  shipmentManifestOptionsDescription: {
    description: 'Shipment manifest print setup modal description',
    defaultMessage: 'Choose how your Shipment Manifest appear.',
    id: '3ERJ4v',
  },
  itemNamesLabel: {
    description: 'Shipment manifest list item names label',
    defaultMessage: 'Item Names',
    id: 'aXyqZj',
  },
  itemNamesOption: {
    description: 'Shipment manifest list item names option',
    defaultMessage: 'List items for each order in the shipment manifest',
    id: 'PIbAjz',
  },
});

export default messages;
